<p class="task-title">
    Задание {{ exerIndex + 1 }}
</p>
<!-- Условие задачи-->
<p class="condition-task">
    <ng-katex *ngIf="isKatexFormat(exercise)" class="katex" [equation]="exercise.text"></ng-katex>
    <ng-katex-paragraph *ngIf="!isKatexFormat(exercise)" [paragraph]="exercise.text"></ng-katex-paragraph>
</p>
<div *ngIf="exercise.type === task">
    <app-question-task
            *ngFor="let question of exercise.questions; let qIndex = index;"
            [question]="question"
            [exercise]="exercise"
            [cardId]="cardId"
            [isAccessCard]="isAccessCard"
            [isAuthorCard]="isAuthorCard"
            [prev_results]="prev_results"
            [studentId]="studentId"
            [qIndex]="qIndex"
            (questionAnswered)="questionAnswered($event)"
    ></app-question-task>
</div>
<div *ngIf="exercise.type === logic">
    <app-question-logic
            *ngFor="let question of exercise.questions; let qIndex = index;"
            [question]="question"
            [exercise]="exercise"
            [cardId]="cardId"
            [isAccessCard]="isAccessCard"
            [isAuthorCard]="isAuthorCard"
            [prev_results]="prev_results"
            [studentId]="studentId"
            [qIndex]="qIndex"
            (questionAnswered)="questionAnswered($event)"
    ></app-question-logic>
</div>
<br>
